var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wrap" } },
    [
      _c("MainHeader", { attrs: { title: "", cart: "N" } }),
      _c(
        "section",
        [
          _c("section", { staticClass: "setting_easy" }, [
            _c(
              "div",
              {
                staticClass: "setting_easy_wrap",
                staticStyle: { display: "none" }
              },
              [
                _vm._m(0),
                _vm._l(_vm.groupRecoGoods, function(group, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "setting_easy_list",
                      staticStyle: { display: "none" }
                    },
                    [
                      _c("h5", [
                        _vm._v(_vm._s(group.group_nm) + " "),
                        _c("i", {
                          staticClass: "xi-close",
                          staticStyle: { "margin-left": "10px" },
                          attrs: { onclick: "modal('reco_setting_03')" },
                          on: {
                            click: function($event) {
                              _vm.selectedIndex = i
                            }
                          }
                        })
                      ]),
                      _c(
                        "ul",
                        { staticClass: "product_list" },
                        _vm._l(_vm.recoGoods, function(reco) {
                          return _c(
                            "li",
                            {
                              key: reco.good_no,
                              on: {
                                click: function($event) {
                                  ;[
                                    (_vm.selectedGroupIndex = i),
                                    (_vm.selectedGoods = reco)
                                  ]
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    product_list_box: true,
                                    active:
                                      group.good_nos.indexOf(reco.good_no) > -1
                                  },
                                  attrs: { id: i + "_" + reco.good_no + "_box" }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.$refs.goodDtl.searchGood(
                                            _vm.$route.params.event_no,
                                            reco.good_no,
                                            group.good_nos.indexOf(
                                              reco.good_no
                                            ) > -1
                                              ? 1
                                              : 0,
                                            "N"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "thumb" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              _vm.$store.getters[
                                                "systemStore/getImgPath"
                                              ] + reco.img_path,
                                            alt: reco.good_nm
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "check" + i + "_" + reco.good_no
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "info" }, [
                                        _c("p", [_vm._v(_vm._s(reco.good_nm))]),
                                        _c("strong", [
                                          _c("em", [
                                            _vm._v(
                                              _vm._s(
                                                reco.sale_price.toLocaleString()
                                              )
                                            )
                                          ]),
                                          _vm._v("원")
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "input-form-checkbox" },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          id: "check" + i + "_" + reco.good_no
                                        },
                                        domProps: {
                                          checked:
                                            group.good_nos.indexOf(
                                              reco.good_no
                                            ) > -1
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.addCart()
                                          }
                                        }
                                      }),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for:
                                              "check" + i + "_" + reco.good_no
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "xi-check-min"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "txt-center", staticStyle: { display: "none" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn_add_group",
                    on: {
                      click: function($event) {
                        return _vm.addGroup()
                      }
                    }
                  },
                  [_c("i", { staticClass: "xi-plus-min" }), _vm._v("그룹추가")]
                )
              ]
            )
          ]),
          _c("Footer")
        ],
        1
      ),
      _c("GoodDtl", {
        ref: "goodDtl",
        attrs: { price_hidden: false },
        on: { addcart: _vm.emitAddCard }
      }),
      _c("div", { staticClass: "popup reco_setting_01" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", [_vm._v(_vm._s(_vm.alertMsg))])
          ]),
          _vm._m(1)
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("div", { staticClass: "popup reco_setting_02" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _c("div", { staticClass: "popup_button" }, [
            _c(
              "button",
              {
                staticClass: "btn_large",
                on: {
                  click: function($event) {
                    return _vm.$router.replace("dispGoods")
                  }
                }
              },
              [_vm._v("확 인")]
            )
          ])
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("div", { staticClass: "popup reco_setting_03" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _vm._m(2),
          _c("div", { staticClass: "popup_button" }, [
            _c(
              "button",
              {
                staticClass: "btn_large",
                on: {
                  click: function($event) {
                    return _vm.deleteGroupAndGoods()
                  }
                }
              },
              [_vm._v("확 인")]
            ),
            _c(
              "button",
              {
                staticClass: "btn_large",
                attrs: { onclick: "modal('reco_setting_03')" }
              },
              [_vm._v("취 소")]
            )
          ])
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("Progress", { attrs: { active: _vm.progressActive } }),
      _c(
        "div",
        {
          class: { progress: true, active: _vm.active },
          attrs: { id: "progress" }
        },
        [
          _c("div", { staticClass: "dimBg" }),
          _c("p", [_vm._v("데이터를 불러오는 중입니다.")])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "txt-center" }, [
      _vm._v(" 선물 받을 분들을 그룹을 나누고"),
      _c("br"),
      _vm._v(" 그룹별로 선물(1~5개)을 보낼 수 있어요."),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        {
          staticClass: "btn_large",
          attrs: { onclick: "modal('reco_setting_01')" }
        },
        [_vm._v("확 인")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_content" }, [
      _c("p", [_vm._v("해당 그룹과 선택하신 상품을 삭제하시겠습니까?")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }